import React from "react";
import { Link } from "react-router-dom";

export default function GroupTalkSessionList() {
  return (
    <main className="min-h-screen overflow-x-hidden bg-[radial-gradient(circle_at_top,_rgba(250,233,220,0.95),_rgba(255,249,245,1)_55%)] px-4 py-6 text-[#4A3E39] sm:px-6 sm:py-10">
      <div className="mx-auto w-full max-w-3xl">
        <header className="mb-6 flex items-center justify-between">
          <Link to="/talk/group" className="text-sm font-bold text-[#A67C52] hover:text-[#7C5A4E]">
            ← 戻る
          </Link>
          <p className="text-sm font-bold tracking-tight text-[#7C5A4E]">会議セッション一覧</p>
          <Link to="/home" className="text-xs font-bold text-[#9C867D] hover:text-[#7C5A4E]">
            WizMate
          </Link>
        </header>

        <section className="rounded-[2.4rem] border border-white/80 bg-white/90 p-6 shadow-[0_24px_60px_rgba(124,90,78,0.16)] backdrop-blur-sm sm:p-7">
          <p className="text-xs font-black uppercase tracking-[0.18em] text-[#A67C52]">Session List</p>
          <h1 className="mt-3 text-3xl font-black tracking-tight text-[#7C5A4E]">続きから話す</h1>
          <p className="mt-3 text-sm leading-7 text-[#6B5851]">
            過去のセッション一覧から会議の続きを始めるためのルートです。ここは後で本実装します。
          </p>
          <div className="mt-8 rounded-[1.8rem] border border-dashed border-[#D9C5B9] bg-[#FFFBF8] p-5 text-sm leading-6 text-[#6B5851]">
            セッション一覧 UI は後で追加予定です。
          </div>
        </section>
      </div>
    </main>
  );
}
